var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,7.9c-0.2-0.3-0.5-0.4-0.8-0.4L12.3,6.6c-0.6,0-1,0.4-1.1,1c0,0.6,0.4,1,1,1.1l18.1,0.8l-3.6,11.1H10.9 L8,4.9C7.9,4.6,7.7,4.3,7.4,4.2L2.7,2.3C2.2,2.1,1.6,2.4,1.4,2.9C1.2,3.4,1.5,4,1.9,4.2l4.2,1.6L9,21.7c0.1,0.5,0.5,0.8,1,0.8h0.5 l-1.1,3.1c-0.2,0.4,0.1,0.9,0.5,1.1c0.1,0,0.2,0.1,0.3,0.1H11c-1.1,1.2-1,3.1,0.2,4.3c1.2,1.1,3.1,1,4.3-0.2c1-1.1,1-2.9,0-4H22 c-1.1,1.2-1,3.1,0.2,4.3c1.2,1.1,3.1,1,4.3-0.2c1-1.1,1-2.9,0-4h0.9c0.5,0,0.9-0.3,0.9-0.8c0-0.5-0.3-0.9-0.8-0.9c0,0-0.1,0-0.1,0 H11.4l0.9-2.5h15.2c0.4,0,0.8-0.3,1-0.7l4.2-13.1C32.7,8.4,32.7,8.1,32.5,7.9L32.5,7.9L32.5,7.9z M13.2,30.1c-0.7,0-1.3-0.6-1.4-1.3 c0-0.7,0.6-1.3,1.3-1.4c0.7,0,1.3,0.6,1.4,1.3c0,0,0,0,0,0C14.6,29.5,14,30.1,13.2,30.1L13.2,30.1L13.2,30.1z M24.3,30.1 c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C25.6,29.5,25,30.1,24.3,30.1L24.3,30.1L24.3,30.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.716b41c932358f84b6afc7c75a41c50d.svg";
export { ForwardRef as ReactComponent };